export const GET_OWNERS_CACHE_KEY = 'ownersCache';
export const GET_APPS_CACHE_KEY = 'appsCache';

export const cacheVariables = {
	[GET_OWNERS_CACHE_KEY]:{
		expiry: 8 * 60 * 60 * 1000, 
		useCache: true 
	},
	[GET_APPS_CACHE_KEY]:{
		expiry: 1 * 60 * 60 * 1000,
		useCache: true
	}
}
